import notificationWithIcon from '@/utils/notification';
import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';
import types from './types';

const actions = {
  async getStatuses({ commit }) {
    try {
      commit(types.GET_STATUSES_START);
      const { data: { data: statusesData } } = await apiCall({
        type: 'GET',
        url: `${URLS.orderAndProjectStatuses}`,
        isToken: true,
      });
      commit(types.GET_STATUSES_SUCCESS, statusesData);
    } catch (e) {
      const { response: { data: { message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_STATUSES_ERROR, message);
    }
  },
  async saveStatus({ dispatch, commit }, { id, ...rest }) {
    try {
      commit(types.SAVE_STATUSES_START);
      await apiCall({
        type: 'PUT',
        url: `${URLS.orderAndProjectStatuses}/${id}`,
        body: rest,
        isToken: true,
      });
      notificationWithIcon('success', 'Status updated');
      dispatch('getStatuses');
      commit(types.SAVE_STATUSES_SUCCESS);
    } catch (err) {
      const { response: { data: { message } } } = err;
      notificationWithIcon('error', message);
      commit(types.SAVE_STATUSES_ERROR);
    }
  },
};

export default actions;
